import $ from 'jquery'
import 'jquery.nicescroll'

let $wrap = $('.section-wrap.section-about')
let $content = $wrap.find('.info > .content')

const limitContentHeight = () =>{
    $content.css({'maxHeight':100000})

    // if($('body').width() > 768 ){//$wrap.find('.im > img:visible').length && 
    //     let $info = $wrap.find('.info');
    //     let maxHeight = $wrap.height() - parseInt($info .css('marginTop')) - parseInt($info .css('marginBottom')) - parseInt($info .css('paddingTop')) - parseInt($info .css('paddingBottom'))
    //     // let imHeight = $wrap.find('.im > img:visible').height();
    //     $wrap.find('.info').height(maxHeight)
    // }

    console.log($wrap.children('.im').length);
    if($wrap.children('.im').length && $('body').width() > 768 ){
        let imHeight = $wrap.children('.im').outerHeight();
        $wrap.find('.info').height(imHeight)
    }

    let height = $content.outerHeight();
    let lineHeight = parseFloat($content.css('lineHeight'))
    let line = Math.floor(height/lineHeight);
    let maxHeight = line * lineHeight;
    $content.css({'maxHeight':maxHeight})
    $content.getNiceScroll().resize();
}

export default {
    init(){
        $(()=>{
            
            if($wrap.children('.im').length){
                let $im = $wrap.children('.im').clone()
                $im.attr('class','im mobile');
                $wrap.find('.info > .headline').after($im)
                
            }

            limitContentHeight();

            $content.niceScroll({touchbehavior:true,cursorwidth: "0px",cursorborder:'none',grabcursorenabled: false});
            // .niceScroll({touchbehavior:true,grabcursorenabled: false});
        })
        
        $(window).resize(()=>{
            limitContentHeight();
        })
    }
}